import { Group, Button, Anchor, Box } from '@mantine/core'
import { Link, useMatchRoute } from '@tanstack/react-router'
import { IconLogout, IconHome, IconPhoto, IconEdit, IconArmchair } from '@tabler/icons-react'
import { clearAdminSession } from '../../lib/auth'
import { useNavigate } from '@tanstack/react-router'
import styles from './AdminNavbar.module.css'

/**
 * Admin navigation bar with Home and Gallery links
 * Includes logout functionality
 */
export function AdminNavbar() {
  const navigate = useNavigate()
  const matchRoute = useMatchRoute()

  // Check which page is currently active
  const isHomeActive = matchRoute({ to: '/admin', fuzzy: true })
  const isGalleryActive = matchRoute({ to: '/admin/gallery', fuzzy: true })
  const isContentActive = matchRoute({ to: '/admin/content', fuzzy: true })
  const isSeatingActive = matchRoute({ to: '/admin/seating', fuzzy: true })

  const handleLogout = () => {
    clearAdminSession()
    navigate({ to: '/admin/login' })
  }

  return (
    <div className={styles.navbar}>
      <Group gap="md" className={styles.navLinks} mt="-0.1rem">
        <Anchor
          py="4px"
          px="sm"
          component={Link}
          to="/admin"
          className={`${styles.navLink} ${isHomeActive ? styles.navLinkActive : ''}`}
        >
          <Group gap="xs">
            <IconHome size={20} />
            <Box mt="0.1rem">Home</Box>
          </Group>
        </Anchor>
        <Anchor
          py="4px"
          px="sm"
          component={Link}
          to="/admin/content"
          className={`${styles.navLink} ${isContentActive ? styles.navLinkActive : ''}`}
        >
          <Group gap="xs">
            <IconEdit size={20} />
            <Box mt="0.1rem">Inhalte bearbeiten</Box>
          </Group>
        </Anchor>
        <Anchor
          py="4px"
          px="sm"
          component={Link}
          to="/admin/gallery"
          className={`${styles.navLink} ${isGalleryActive ? styles.navLinkActive : ''}`}
        >
          <Group gap="xs">
            <IconPhoto size={20} />
            <Box mt="0.1rem">Galerie</Box>
          </Group>
        </Anchor>
        <Anchor
          py="4px"
          px="sm"
          component={Link}
          to="/admin/seating"
          className={`${styles.navLink} ${isSeatingActive ? styles.navLinkActive : ''}`}
        >
          <Group gap="xs">
            <IconArmchair size={20} />
            <Box mt="0.1rem">Sitzplan</Box>
          </Group>
        </Anchor>
      </Group>

      <Group gap="sm" className={styles.rightSection}>
        <Button
          leftSection={<IconLogout size={18} />}
          variant="subtle"
          color="red"
          onClick={handleLogout}
          className={styles.logoutButton}
        >
          Abmelden
        </Button>
      </Group>
    </div>
  )
}
